import { useRecurringGifts } from "CrossFeatureComponents/UserRecurringGifts/RecurringGiftsContext";

const getDate5YearsFromNow = () => {
  let currentDate = new Date();
  let futureDate = new Date();
  let currentYear = currentDate.getFullYear();
  return futureDate.setFullYear(currentYear + 5);
};

/*
  We are looking for the payment(s) that are "next up"... aka they have the soonest next payment date.
  Note that multiple gifts might match this date.
*/

export function useGetNextPayments() {
  const { state } = useRecurringGifts();
  const gifts = state?.recurringGifts || [];

  let dateOfEarliestGift = getDate5YearsFromNow();

  gifts
    .filter((gift) => {
      // filter out non-active gifts
      return !gift.isPaused && !gift.isDeleted && gift.status !== "expired";
    })
    .forEach((gift) => {
      const date = new Date(gift.nextPaymentDateCachedForDisplayOnly);

      if (date < dateOfEarliestGift) {
        // update dateOfEarliestGift if this gift is the earliest one we've found
        dateOfEarliestGift = date;
      }
    });

  // return any gifts that match the dateOfEarliestGift
  return gifts.filter((gift) => {
    const giftDate = new Date(gift.nextPaymentDateCachedForDisplayOnly);
    return giftDate.toString() === dateOfEarliestGift.toString();
  });
}
